import React, { Fragment } from "react"

import { languageCodeMapping } from "../../../../config/language-definitions"
import {
    regionToParentRegion,
    contentTypeLabels,
} from "../../../../config/application-definitions"

import Tags from "../../../common/tags/Tags"
import TagItem from "../../../common/tags/TagItem"
import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"
import ContentLoaderTags from "../../../common/content-loading/ContentLoaderTags"

const SourceViewItemDetails = ({
    type,
    lastImportTime,
    preserveArticleLinks,
    publicationType,
    contentType,
    country,
    region,
    language,
    license,
    autoApproved,
    isFetching,
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-source" />
                Source type
            </h3>
            <ContentLoaderTags isFetching={isFetching} tags={1}>
                {type ? (
                    <Tags>
                        <TagItem isGrey={true}>{type}</TagItem>
                    </Tags>
                ) : (
                    <p>No type</p>
                )}
            </ContentLoaderTags>
            <h3>
                <i className="icon icon-article" />
                Last import
            </h3>
            <ContentLoaderLines isFetching={isFetching} lineLength={30}>
                <p>
                    {lastImportTime
                        ? lastImportTime.local().format("llll")
                        : "Unknown"}
                </p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-article" />
                Preserve article links
            </h3>
            <ContentLoaderLines isFetching={isFetching}>
                <p>
                    {preserveArticleLinks
                        ? "Article links are unaltered by scraper"
                        : "Article links are determined by scraper (default)"}
                </p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-license" />
                Publication type
            </h3>
            <ContentLoaderTags isFetching={isFetching} tags={1}>
                {publicationType ? (
                    <Tags>
                        <TagItem isGrey={true}>{publicationType}</TagItem>
                    </Tags>
                ) : (
                    <p>No publication type</p>
                )}
            </ContentLoaderTags>
            <h3>
                <i className="icon icon-article" />
                Content type
            </h3>
            <ContentLoaderTags isFetching={isFetching} tags={1}>
                {contentType ? (
                    <Tags>
                        <TagItem isGrey={true}>
                            {contentTypeLabels[contentType] || contentType}
                        </TagItem>
                    </Tags>
                ) : (
                    <p>No content type</p>
                )}
            </ContentLoaderTags>
            <h3>
                <i className="icon icon-source" />
                Country
            </h3>
            <ContentLoaderTags isFetching={isFetching} tags={1}>
                {country ? (
                    <Tags>
                        <TagItem isGrey={true}>{country}</TagItem>
                    </Tags>
                ) : (
                    <p>No country</p>
                )}
            </ContentLoaderTags>
            {region && (
                <Fragment>
                    <h3>
                        <i className="icon icon-source" />
                        Region
                    </h3>
                    <ContentLoaderTags isFetching={isFetching} tags={1}>
                        <Tags>
                            <TagItem isGrey={true}>{region}</TagItem>
                        </Tags>
                    </ContentLoaderTags>
                </Fragment>
            )}
            {region && regionToParentRegion[region] && (
                <Fragment>
                    <h3>
                        <i className="icon icon-source" />
                        Greater region
                    </h3>
                    <ContentLoaderTags isFetching={isFetching} tags={1}>
                        <Tags>
                            <TagItem isGrey={true}>
                                {regionToParentRegion[region]}
                            </TagItem>
                        </Tags>
                    </ContentLoaderTags>
                </Fragment>
            )}
            <h3>
                <i className="icon icon-lang" />
                Article language
            </h3>
            <ContentLoaderLines isFetching={isFetching} lineLength={30}>
                <p>{getLanguageDisplay(language)}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-license" />
                License
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLineLength={30}
                maxLineLength={70}
            >
                <p>{license || "No license"}</p>
            </ContentLoaderLines>
            <h3>
                <i className="icon icon-autopilot" />
                Autopilot
            </h3>
            <ContentLoaderTags isFetching={isFetching} tags={1} tagLength={25}>
                {autoApproved ? (
                    <Tags>
                        <TagItem isGrey={true}>{autoApproved}</TagItem>
                    </Tags>
                ) : (
                    <p>Off</p>
                )}
            </ContentLoaderTags>
        </div>
    </div>
)

function getLanguageDisplay(language) {
    const mappedLanguage = languageCodeMapping[language]
    if (mappedLanguage) {
        return mappedLanguage.name
    } else if (language) {
        return "Unknown language"
    } else {
        return "Using language detection"
    }
}

export default SourceViewItemDetails
